import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { createPortal } from 'react-dom';
import './Modal.css';

const Modal = ({
  isOpen,
  onClose,
  title,
  message,
  buttons = [],
  children,
  size = 'medium',
  icon = null
}) => {
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const getButtonClass = (button) => {
    if (button.className === 'danger') return 'btn-danger';
    if (button.className === 'primary') return 'btn-confirm';
    return 'btn-cancel';
  };

  const dialogContent = (
    <AnimatePresence>
      {isOpen && (
        <div className="modal-overlay" onClick={handleBackdropClick}>
          <motion.div
            className={`subtle-dialog qinto-modal-dialog dialog-${size}`}
            initial={{ opacity: 0, scale: 0.96, y: 14 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.96, y: 14 }}
            transition={{ duration: 0.2 }}
            onClick={(event) => event.stopPropagation()}
          >
            {icon && <div className="dialog-icon qinto-modal-icon">{icon}</div>}
            
            {title && <h3>{title}</h3>}
            
            <div className="dialog-content">
              {message && <p>{message}</p>}
              {children}
            </div>

            {buttons.length > 0 && (
              <div className="dialog-actions">
                {buttons.map((button, index) => (
                  <button
                    key={index}
                    className={getButtonClass(button)}
                    onClick={button.onClick}
                  >
                    {button.label}
                  </button>
                ))}
              </div>
            )}
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );

  return createPortal(dialogContent, document.body);
};

export default Modal;
